<template>
<div class="popup" v-show="taskSingleShow" v-cloak id="taskSinglePop">
    <div id="pleaseSelect" class="content">
        <div class="title">
            <span>{{$t('language.popup.cloudTransferPopup.pleaSelect')}}</span>
            <div class="icon white-close dialog-close" @click="taskSigleClose"></div>
        </div>
        <div class="task-content" v-loading="loading" ref="aimTree">
             <el-scrollbar style="height:100%;" ref="elscrollbar">
            <div v-if="!realTimeMode">
            <div v-if="!model.length&&!loading" class="nondrive-des" @click="toAddCloudPage()">
                {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
            </div>
            </div>
            <div v-else>
               <div v-if="!model.length&&!loading" class='real-nodrives'  @click="toAddCloudPage()">
               <div class="nondrive-realtime"></div>
               <div class="nondrive-realtimedes">
                    {{$t('language.popup.cloudTransferPopup.addValidCloud')}}
               </div>
               </div>
            </div>
            <div class="tree-nodes" id="treeNodes">
                <ul :key="index" v-for="(item,index) in model">
                    <tree ref="tree" :model="item" :index="index" :treeShow=true :transferAimFlag=transferAimFlag></tree>
                </ul>
            </div>
            </el-scrollbar>
        </div>
        <div class="task-footer">
            <button class="task-button" @click="singleSubmit()">{{$t('language.common.ok')}}</button>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import tree from "@/components/common/trees/tree";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            taskSingleShow: false,
            model: [],
            transferAimFlag: true,
            checkedNodes: '',
            loading: true,
            flag: true,
            scrollTopValue: 0,
            realTimeMode:true,
            pass:[],
        };
    },
    mounted() {
        this.$store.commit('setClickItem', null);
        this.$store.commit('setArr', -1);
        let that = this;
        this.loading = true;
        this.model = Object.assign([], this.$store.getters.getUsersDrives).filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
        if (!this.model.length&&(that.$route.name == 'cloudTransfer'||that.$route.name=='cloudBackup')) {
            this.model = this.Utils.getAllCloudsList(function (res) {
                if (res.status == 200) {
                    that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
                    that.loading = false;
                }
            });
        } else {
            this.loading = false;
        }
        //不需要邮箱
        // that.model = that.model.filter(cloud => !commonstate.emailClouds.includes(cloud.driveType));
        $.each(this.model, function (index, item) {
            if (item.children && item.children.length) {
                item.open = false;
                delete item.children;
            }
        });
    },
    watch:{
        taskSingleShow(newValue,oldValue){
            var _self = this;
            var arr=[];
            if(this.$route.name!='cloudBackup' || !newValue){
              return;
            }
            //不再屏蔽部分云盘
            // var notSupportDrive = ['oneDrive4Business','baiDu','sharedWithMe','boxBusiness','sharedDrive']
            // for (let index = 0; index < this.model.length; index++) {
            //     const element = this.model[index];
            //      if(!notSupportDrive.includes(element.appName)){
            //         arr.push(element);
            //    }
            // }
            // this.model = arr;
        },
    },
    methods: {
        taskSigleClose() {
            let that=this;
            that.taskSingleShow= false;
            if (!this.$store.state.clickItem || !this.$parent.singleDrives.name) {
                $.each(this.model, function (index, item) {
                    item.open = false;
                    if (item.children&&item.children.length) {
                        commonUtils.closeTree(item.children);
                    }
                });
                //  this.$nextTick(() => {
                //               that.$refs['elscrollbar'].wrap.scrollTop=0;
                // });
                // setTimeout(()=>{
                //           that.taskSingleShow= false;
                // },10);
                this.scrollTopValue = 0;
            }
        },
        refresh(){
           this.$forceUpdate();
        },
        toAddCloudPage() {
            let dom;
            let that = this;
            $.each(that.$parent.$parent.$children, function (i, item) {
                if (item.menuOptions) {
                    dom = that.$parent.$parent.$children[i];
                    dom.menuOptionSelect(10);
                    return;
                }
            });
        },
        getFilePath(json, nodes) {
            node = null;
            if (nodes == null) return "";
            let fileName = nodes.name;

            var res = this.getNode(json, nodes.id);
            var pNode = res.parentNode;
            if (pNode != null) {
                if (pNode.name != null && pNode != undefined) {
                    fileName = this.getFilePath(json, pNode) + "/" + fileName;
                }
            }
            return fileName;
        },
        singleSubmit() {
            let that = this;
            let node = this.$store.state.clickItem;
            if( this.$parent.pageName == 'cloudBackup'){
                 var driveId;
                   if(node.driveInfo && node.driveInfo.id){
                      driveId = node.driveInfo.id;
                  }else{
                      driveId = node.driveId;
                   }
                if(!this.pass.includes(driveId) &&node.afterBackup != undefined && !node.afterBackup){
                this.$parent.$refs.readdCloudDialog.nodes.push(node);
                this.$parent.$refs.readdCloudDialog.readdShow = true;
                this.$parent.$refs.readdCloudDialog.source='aim';
                 return;
                }
                if(!this.pass.includes(driveId) && node.afterBackup == undefined &&  !node.driveInfo.afterBackup){
                this.$parent.$refs.readdCloudDialog.nodes.push(node);
                this.$parent.$refs.readdCloudDialog.readdShow = true;
                this.$parent.$refs.readdCloudDialog.source='aim';
                 return;
                }

            }
            let pKey;
            if (node) {
                let type = node.driveType;
                let pathArray = taskTransferUtils.findFilePathArray(this.model, node, []);
                let path = pathArray[0];
                for (let i = 1; i < pathArray.length; i++) {
                    path = path + '\\' + pathArray[i];
                }
                node.driveType = type;
                node.cloudCatalog = path;
                let sourceCatalogArr = [];
                //判断路径是否重复 且源目录的id不能是父目录的父id
                if (this.$parent.mulitDrives.length) {
                    for (let i = 0; i < this.$parent.mulitDrives.length; i++) {
                        pKey = this.$parent.mulitDrives[i].keyId + this.$parent.mulitDrives[i].formUrl;
                        sourceCatalogArr.push(pKey);
                    }
                    this.flag = taskTransferUtils.checkCatalog(sourceCatalogArr, node);
                    if (this.flag == false) {
                        that.$toast({
                            text: that.$t('language.exception.notBeTheSame'),
                            type: 'fail',
                            idValue: "taskSinglePop",
                            learnMoreShow: true
                        });
                        return false;
                    }
                }

                if (this.flag) {
                    this.checkedNodes = node;
                    this.$parent.singleDrives = node; //如果父弹窗目标未包括该选项，则赋值
                    this.$parent.hasSelect = false;
                    this.taskSingleShow = false;
                    if (!path) {
                        this.$parent.hasSelect = true;
                    }
                }
            }
            this.scrollTopValue = this.$refs.aimTree.scrollTop;
            this.$refs.aimTree.scrollTop = 0;
        },
    },
    components: {
        tree
    }
};
</script>

<style>
.el-scrollbar .el-scrollbar__wrap {
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_transfer_popups/task_single_popup.vue